import Badge from "../../components/Badge";
import Avatar from 'react-avatar';
import ActionButton from "./ActionButton";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import {Link} from "react-router-dom";
import ProductStockModal from "./ProductStockModal";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";
import CopyToClipBoard from "../../components/CopyToClipBoard";

function Product({product}) {
    const productUrl = product.product_url;
    const productHref = productUrl && /^https?:\/\//i.test(productUrl)
        ? productUrl
        : productUrl
            ? `https://${productUrl}`
            : null;
    const shortProductUrl = product.short_product_url;
    const shortProductHref = shortProductUrl && /^https?:\/\//i.test(shortProductUrl)
        ? shortProductUrl
        : shortProductUrl
            ? `https://${shortProductUrl}`
            : null;
    const renderCopyableLink = (url, href) => {
        if (url === null) {
            return <NoneValue/>;
        }

        return (
            <CopyToClipBoard link={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {url}
                </a>
            </CopyToClipBoard>
        );
    };

    const [productDetailsModal, setProductDetailsModal] = useState(false);
    const productDetailsModalToggle = () => setProductDetailsModal(!productDetailsModal);

    const [stockHistoryModal, setStockHistoryModal] = useState(false);
    const stockHistoryModaltoggle = () => setStockHistoryModal(!stockHistoryModal);

    return (
        <>
            <tr>
                <td>

                    {product.image ? <img src={product.image}
                                          className="avatar-sm img-thumbnail rounded-circle" alt={"product"}/>
                        : <Avatar size={35} name={product.name} round/>}

                </td>
                <td onClick={productDetailsModalToggle}>
                    <Link className="text-primary">{product.name === null? <NoneValue/> : product.name}</Link>
                </td>
                <td className="text-muted font-13">{product.price === null? <NoneValue/> : product.price}</td>
                <td className="text-muted font-13">
                    {renderCopyableLink(shortProductUrl, shortProductHref)}
                </td>
                <td>
                    <Badge badge={
                        product.status === "ACTIVE"
                            ? "badge badge-light-success"
                            : "badge badge-light-danger"
                    } status={product.status === null? <NoneValue/> : product.status}/>
                </td>
                <td>{product.stock === null? <NoneValue/> : product.stock}</td>
                <td>{product.is_inventory_tracking_enabled ? <i className="mdi mdi-check mr-2 font-18 text-success"/>: <i className="mdi mdi-close mr-2 font-18 text-danger"/>}</td>
                <td>{new Date(product.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                <ActionButton product={product}/>
            </tr>

            <Modal className={'modal-xl'} isOpen={productDetailsModal} toggle={productDetailsModalToggle}>
                <ModalHeader toggle={productDetailsModalToggle} close={
                    <button className="close" onClick={productDetailsModalToggle}>
                        &times;
                    </button>
                }>Product details: {product.name}</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{product.name === null? <NoneValue/> : product.name}</h4>
                        <p className="sub-header">

                                {product.image ? <img src={product.image}
                                                      className="avatar-xl img-thumbnail rounded-circle" alt={"product"}/>
                                    : <Avatar size={95} name={product.name} round/>}
                        </p>

                        <div className="table-responsive">
                            <table className="table mb-0">

                                <tbody>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Product ID</td>
                                    <td>{product.id === null ? <NoneValue/> : product.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Product Name</td>
                                    <td>{product.name === null ? <NoneValue/> : product.name}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Price</td>
                                    <td>{product.price === null ? <NoneValue/> : product.price}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Product URL</td>
                                    <td>{renderCopyableLink(productUrl, productHref)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Short Product URL</td>
                                    <td>{renderCopyableLink(shortProductUrl, shortProductHref)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Add-Ons Supported</td>
                                    <td>{product.add_ons_supported?.count ?? <NoneValue/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Price After Tax</td>
                                    <td>{product.price_after_tax}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Description</td>
                                    <td>{product.description === "" ? <NoneValue/> : product.description}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Inventory Tracking Enabled</td>
                                    <td>{product.is_inventory_tracking_enabled ?
                                        <i className="mdi mdi-check mr-2 font-18 text-success"/> :
                                        <i className="mdi mdi-close mr-2 font-18 text-danger"/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Stock</td>
                                    <td>
                                        {product.stock !== null ? (
                                            <>
                                                {product.stock}
                                                <Button
                                                    onClick={stockHistoryModaltoggle}
                                                    color="#4d5bed"
                                                    className='bx-btn-primary ml-2'
                                                >
                                                    View Stock History
                                                </Button>
                                            </>
                                        ) : (
                                            <Button
                                                onClick={stockHistoryModaltoggle}
                                                color="#4d5bed"
                                                className='bx-btn-primary'
                                            >
                                                View Stock History
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Status</td>
                                    <td><Badge badge={
                                        product.status === "ACTIVE"
                                            ? "badge badge-light-success"
                                            : "badge badge-light-danger"
                                    } status={product.status === null ? <NoneValue/> : product.status}/></td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>UPC</td>
                                    <td>{product.upc === "" ? <NoneValue/> : product.upc}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Digital</td>
                                    <td>{product.is_digital === true
                                        ? <i className="mdi mdi-check mr-2 font-18 text-success"/> :
                                        <i className="mdi mdi-close mr-2 font-18 text-danger"/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>HSN/SAC</td>
                                    <td>{product.hsn_sac === "" ? <NoneValue/> : product.hsn_sac}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Unit of Measure</td>
                                    <td>{product.unit_of_measure === "" ? <NoneValue/> : product.unit_of_measure}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Tax Type</td>
                                    <td>{product.tax_type}</td>

                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Tax Percentage</td>
                                    <td>{product.tax_percentage} %</td>

                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Tax Amount</td>
                                    <td>{product.tax_amount}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Price Before Tax</td>*/}
                                {/*    <td>{product.price_before_tax}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Owner</td>*/}
                                {/*    <td>{product.owner === null ? <NoneValue/> : product.owner}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"></th>
                                    <td>Created</td>
                                    <td>{new Date(product.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Updated</td>
                                    <td>{new Date(product.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <ProductStockModal product={product} modal={stockHistoryModal} modalToggle={stockHistoryModaltoggle}/>

        </>

    );
}

export default Product;
